import { createContext } from "react";

const ActeurContext = createContext();

export default ActeurContext;

